import { render, staticRenderFns } from "./MessageReplyStateSetupView.vue?vue&type=template&id=47430fde&scoped=true&"
import script from "./MessageReplyStateSetupView.vue?vue&type=script&lang=ts&"
export * from "./MessageReplyStateSetupView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47430fde",
  null
  
)

export default component.exports